export const AGVIEWER = 67;
export const API_KEY_SEAT = 35;
export const USER_SEAT = 34;
export const PHENOLOGY_MANAGEMENT = 14;
export const CDTEC_API = 13;
export const AG_ANALYTICS_SPA = 12;
export const CERES_IMAGING = 11;
export const SDB_CONVERTER = 10;
export const SELF_MANAGED = 9;
export const REQUEST = 8;
export const ZENTRACLOUD = 7;
export const UFL = 6;
export const IRRIMAX = 5;
export const ARABLE = 4;
export const CERES = 3;
export const DAVIS = 2;
export const WEENAT = 1;


export default { AGVIEWER, API_KEY_SEAT, USER_SEAT, PHENOLOGY_MANAGEMENT, CDTEC_API, AG_ANALYTICS_SPA, CERES_IMAGING,
    SDB_CONVERTER, SELF_MANAGED, REQUEST, ZENTRACLOUD, UFL, IRRIMAX, ARABLE, CERES, DAVIS, WEENAT };
